export default __webpack_public_path__ + "static/mobileHero.f26b1b20.png";